import { combineReducers } from 'redux'
import authReducer from './authReducer'
import loadingReducer from './loadingReducer'
import filterReducer from './filterReducer'

const reducers = combineReducers({
    authReducer,
    loadingReducer,
    filterReducer
})

export default reducers
